/** 云上域名: xinxinhw */
const yunshangDomain = 'xinxinhw';

/**
 * 判断是否是指定域名启动
 * 识别一级域名
 */
const isDomainLaunch = (domain) => {
  try {
    const host = ((window.location && window.location.hostname) || '').toLowerCase();
    if (!host) return false;
    // 本地开发场景直接排除、IPv4 地址、IPv6 地址（方括号表示）直接排除
    if (host === 'localhost') return false;
    if (/^\d{1,3}(\.\d{1,3}){3}$/.test(host)) return false;
    if (/^\[.*\]$/.test(host)) return false;

    // 将主机名按点拆分为段，并去除空段
    const parts = host.split('.').filter(Boolean);
    // 少于两段无法构成正常域名，直接排除
    if (parts.length < 2) return false;

    // 特殊处理的多级后缀（如 com.cn、net.cn 等）
    const cnMultiSuffixes = ['com.cn', 'net.cn', 'org.cn', 'gov.cn', 'edu.cn'];
    // 取末尾两段，判断是否属于多级后缀
    const lastTwo = parts.slice(-2).join('.');
    // 默认取倒数第二段作为一级域名
    let sld = parts.length >= 2 ? parts[parts.length - 2] : '';
    // 若命中多级后缀，向前再取一段作为一级域名
    if (cnMultiSuffixes.includes(lastTwo) && parts.length >= 3) {
      sld = parts[parts.length - 3];
    }

    // 判断一级域名是否为指定域名
    return sld === domain;
  } catch (e) {
    // 出现异常时，返回 false
    return false;
  }
};

/**
 * 是否是云上域名启动
 * xinxinhw
 */
export const IS_YS_DOMAIN = (() => {
  return isDomainLaunch(yunshangDomain);
})();
